(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vault-scrolling-quotes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vv-quote-cycle')) {
customElements.define('vv-quote-cycle', class extends HTMLElement {
connectedCallback() {
this.messages = Array.from(this.querySelectorAll('[data-vv-message]'));
this.current = 0;
this.timer = window.setInterval(() => {
if (this.messages.length < 2) return;
this.messages[this.current].hidden = true;
this.current = (this.current + 1) % this.messages.length;
this.messages[this.current].hidden = false;
}, Number(this.dataset.interval) || 30000);
}
disconnectedCallback() { window.clearInterval(this.timer); }
});
}

  } catch(e) { console.error(e); }
})();
})();
